const abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_starterInfoAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_buidlToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "title",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "starterId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      }
    ],
    name: "PresaleCreated",
    type: "event"
  },
  {
    inputs: [],
    name: "buidlToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address"
          },
          {
            internalType: "uint8",
            name: "tokenDecimals",
            type: "uint8"
          },
          {
            internalType: "address",
            name: "unsoldTokensDumpAddress",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "whitelistedAddresses",
            type: "address[]"
          },
          {
            internalType: "uint256",
            name: "tokenPriceInWei",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "hardCapInWei",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "softCapInWei",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxInvestInWei",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minInvestInWei",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "openTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "closeTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "presaleType",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "guaranteedHours",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "releaseAtTGE",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "releaseCycle",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "releasePerCycle",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "releaseCliff",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "fundingTokenAddress",
            type: "address"
          },
          {
            internalType: "bool",
            name: "certified",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "visible",
            type: "bool"
          },
          {
            internalType: "address[]",
            name: "investorAddresses",
            type: "address[]"
          },
          {
            internalType: "uint256[]",
            name: "investorAmounts",
            type: "uint256[]"
          }
        ],
        internalType: "struct PresaleFactory.PresaleInfo",
        name: "_info",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "listingPriceInWei",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "liquidityAddingTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "lpTokensLockDurationInDays",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "liquidityPercentageAllocation",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "swapIndex",
            type: "uint256"
          }
        ],
        internalType: "struct PresaleFactory.PresalePancakeSwapInfo",
        name: "_cakeInfo",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "saleTitle",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkTelegram",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkGithub",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkTwitter",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkWebsite",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkLogo",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkImgMain",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkImgAlt1",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "linkImgAlt2",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "kycInformation",
            type: "bytes32"
          },
          {
            internalType: "string",
            name: "description",
            type: "string"
          },
          {
            internalType: "bytes32",
            name: "whitepaper",
            type: "bytes32"
          },
          {
            internalType: "uint256",
            name: "categoryId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "saleTypeId",
            type: "uint256"
          }
        ],
        internalType: "struct PresaleFactory.PresaleStringInfo",
        name: "_stringInfo",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "auditor",
            type: "bytes32"
          },
          {
            internalType: "bool",
            name: "isVerified",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "isWarning",
            type: "bool"
          },
          {
            internalType: "string",
            name: "linkAudit",
            type: "string"
          }
        ],
        internalType: "struct PresaleFactory.AuditorInfo",
        name: "_auditInfo",
        type: "tuple"
      }
    ],
    name: "createPresale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_newFactoryAddress",
        type: "address"
      }
    ],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "starterInfo",
    outputs: [
      {
        internalType: "contract StarterInfo",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];

export default abi;
